import { render, staticRenderFns } from "./SwapTransactionDetailsCard.vue?vue&type=template&id=7163d712&scoped=true"
import script from "./SwapTransactionDetailsCard.vue?vue&type=script&lang=ts"
export * from "./SwapTransactionDetailsCard.vue?vue&type=script&lang=ts"
import style0 from "./SwapTransactionDetailsCard.vue?vue&type=style&index=0&id=7163d712&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7163d712",
  null
  
)

export default component.exports